import React, {Component} from 'react';
//import {Link} from "react-router-dom";
import axios from "axios";
import config from 'react-global-configuration';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
//import {confirmAlert} from 'react-confirm-alert';
import ReactTooltip from 'react-tooltip';
//import pending from "../assets/img/pending.png";
//import approve from "../assets/img/approve.png";
//import reject from "../assets/img/reject.png";
import {Button} from "reactstrap";
import jwt_decode from "jwt-decode";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class LinkedView extends Component {
    constructor(props){
        super(props);
        this.state = {
            isSubmit: false,
            //loading: false,
            file_id: null,
            linked_files : [],
            linkedData: {
                id: '',
                user_id: '',
                file_name: '',
                file_path: '',
                timestamp: '',
                version: '',
                cur_version: '',
                status:'',
                user_type: ''
            },
            linkedModel: false,
            data:[],
            raw_display_data: [],
            loading:true,
            _notificationSystem: null,
            versions:[],
            tableLists:[],
            newRelationModel: false,
            relationData: [{ tables:"", columnLists:"", columns:"", id:"", relationToTables:"", toTables:"", toColumnLists:"", toColumns:"" }],
            deleteKeys:[],
            changedItems:[]
        }

    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        //this._getVersions();
        console.log(this.props.match.params);
        this._refreshLinked_View();
        this.setState({ 
            _notificationSystem: this.refs.notificationSystem,
            file_id: this.props.match.params.id       
        });
        //var _notificationSystem = this.refs.notificationSystem;
    }

    linkedData(id, user_id, file_name, file_path, timestamp, version, cur_version, status, user_type) {
        this.setState({
            linkedData: {
                id,
                user_id,
                file_name,
                file_path,
                timestamp,
                version,
                cur_version,
                status,
                user_type
            },
            linkedModel: !this.state.linkedModel
            //login_type:loginType
        });
        this._RawData(user_id, file_name, timestamp)
        //this.findGroups(userType);
        //this.findAccessKeys(id);
    }


    togglelinkedModel() {
        this.setState({
            linkedModel: !this.state.linkedModel
        })
    }

    _refreshLinked_View() {
        if ($.fn.DataTable.isDataTable('#linkedViewTable')) {
            $('#linkedViewTable').DataTable().destroy();
        }
        axios.get(config.get('API_URL') + '/brandemi/view_linked_data',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                file_id: this.props.match.params.id
            }
        }).then(response => {
            console.log(response.data);
            this.setState({
                raw_display_data: response.data
            });
            $('#linkedViewTable').DataTable();
            this.setState({
                loading: false
            });
            //this.preAppender();

        });
    }

    /*preAppender(){
        this.state.raw_display_data.map((value, key) => {
            this.setState({
                changedItems: {...this.state.changedItems, [key]:value[1][0].sku + "$" + value[1][0].brand + "$" + value[1][0].description + "$" + value[1][0].mrp},
                isChange: false
            });
        });
    }*/

    sendBack = () => {
        const yourFunction = async () => {
            await new Promise(resolve => setTimeout(resolve, 1)); // 3 sec
            console.log("Waited 0s");
            this.props.history.push('/admin/master-data');
        };
        yourFunction();
    }

    handleChange(id, e) {
        console.log(id);
        console.log(e.target.value);
        this.setState({
            changedItems: {...this.state.changedItems, [id]:e.target.value},
            isChange: true
        });
    }

    mappingHandler = () => {
        this.setState({
            isSubmit: true,
            loading: true
        });
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // console.log(decoded);
        const data = new FormData();
        data.append('file_id', this.state.file_id);
        data.append('userID', decoded._id);
        data.append('mappings', JSON.stringify(this.state.changedItems));
        data.append('userGroup', decoded.userGroup);
        console.log(data);
        axios.post(config.get('API_URL') + "/brandemi/map_data", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then(res => {
                console.log(res);
                if(res.data.success){
                    this.handleNotificationClick("tr", 1, res.data.success);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                    
                } 
                else {
                    this.handleNotificationClick("tr", 3, res.data.error);
                    this.setState({
                        isSubmit:false,
                        loading:false
                    });
                }
            })
            .catch(err => { // then print response status
                this.handleNotificationClick("tr", 3, "Something Wrong!");
                this.setState({
                    isSubmit:false,
                    loading:false
                })
            })
        };


    
    
    render() {
        console.log(this.state.changedItems);    
        //console.log(this.state.relationData);

        let linked_data = this.state.raw_display_data.map((value,index) => {
            return (
                    <tr key={index + 1}>
                    <td>{index+1}</td>
                    <td>{value.brand_sku}</td>
                    <td>{value.brand_description}</td>
                    <td>{value.brand_price}</td>
                    <td>{value.merchant_sku}</td>
                    <td>{value.merchant_description}</td>
                    <td>{value.merchant_price}</td>
                    <td>{value.timestamp}</td>
                </tr>
            )
        });

        
        return(
            <div className="card-query-builder">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <div className="content">
                    <div className='sweet-loading'>
                        <BeatLoader
                            css={override}
                            sizeUnit={"px"}
                            size={20}
                            color={'#123abc'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Button color="primary" onClick={this.sendBack()}>Go Back</Button>{' '}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">Linked View</h4>
                                    <hr/>
                                </div>
                                <div className="content">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="content table-full-width table-responsive">
                                                <table className="table table-striped table-hover" id="linkedViewTable">
                                                    <thead>
                                                        <tr>
                                                            <th>Sr No.</th>
                                                            <th>Brand SKU</th>
                                                            <th>Brand Description</th>
                                                            <th>Brand Price</th>
                                                            <th>Merchant SKU</th>
                                                            <th>Merchant Description</th>
                                                            <th>Merchant Price</th>
                                                            <th>TImestamp</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {linked_data}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="footer">
                                        {/*<Link className="viewButton" data-tip="View"  ><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>*/}
                                        <div className="stats"><i></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default LinkedView;